import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiteModeDetailComponent } from './site-mode-detail.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
  ],
  declarations: [SiteModeDetailComponent],
  entryComponents: [SiteModeDetailComponent]
})
export class SiteModeDetailModule { }
